<template>
  <el-dialog :visible.sync="visibleSync" title="Xóa tác vụ" :append-to-body="false" :lock-scroll="false" width="420px">
    Bạn có chắc chắn muốn xóa tác vụ này không?
    <span slot="footer" class="dialog-footer d-flex justify-content-end">
      <button class="mt-2 btn btn-secondary font-weight-bold mr-2" @click="close">
        Hủy
      </button>
      <button class="mt-2 btn btn-primary font-weight-bold" @click="$emit('confirm')" :disabled="loading">
        <i v-if="loading" class="fas fa-spinner fa-spin mr-1"></i>
        Chắc chắn
      </button>
    </span>
  </el-dialog>
  
</template>

<script>
export default {
  name: 'DeleteConfirmDialog',
  props: { visible: { type: Boolean, default: false }, loading: { type: Boolean, default: false } },
  computed: {
    visibleSync: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); },
    },
  },
  methods: { close() { this.$emit('update:visible', false); } },
};
</script>

<style scoped>
</style>


